<script setup>
import Tab from '@/components/Shared/Tab.vue';
import { computed } from 'vue';

const props = defineProps({
  ticket: {
    type: Object,
    required: true,
  },
});

const tabs = computed(() => {
  return [
    {
      id: 'communications',
      title: 'Communications',
      route: route('partner-support.tickets.show-communications', { ticket: props.ticket.id }),
      active: route().current('partner-support.tickets.show-communications'),
    },
    {
      id: 'details',
      title: 'Ticket Details',
      route: route('partner-support.tickets.show-details', { ticket: props.ticket.id }),
      active: route().current('partner-support.tickets.show-details'),
    },
    {
      id: 'history',
      title: 'History',
      route: route('partner-support.tickets.show-history', { ticket: props.ticket.id }),
      active: route().current('partner-support.tickets.show-history'),
    },
    {
      id: 'time-registration',
      title: 'Time Registrations',
      route: route('partner-support.tickets.show-time-registrations', { ticket: props.ticket.id }),
      active: route().current('partner-support.tickets.show-time-registrations'),
    },
  ];
});
</script>

<template>
  <div class="py-5">
    <div class="container-fluid">
      <div class="px-4">
        <tab :tabs="tabs" />

        <div class="my-6">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>